<template>
	<v-layout column fill-height v-cloak class="customize">
		<v-flex class="flex-column" v-if="product">
			<v-card-title class="px-0 flex-column__row">
				<h3 class="subheading font-weight-bold secondary--text">
					STEP 3: Customize.
				</h3>
			</v-card-title>

			<v-layout wrap row class="flex-column__row--full">
				<v-flex class="fill-height customize__product">
					<v-card
						class="fill-height flex-column scroll-card"
						color="lightbg"
					>
						<div class="quote-builder__card-inner inner-scroll">
							<v-card-title class="py-0">
								<h4
									class="subheading font-weight-bold secondary--text"
								>
									a. Review Standard Specs
								</h4>
								<v-spacer></v-spacer>
								<v-btn
									flat
									@click="drawingDrawer = !drawingDrawer"
									small
									class="ma-0"
									color="success"
									v-if="
										getObjectValue('drawings', product, [])
											.length
									"
								>
									<span
										v-text="
											drawingDrawer
												? 'Hide Drawings'
												: 'View Drawings'
										"
									></span>
								</v-btn>
							</v-card-title>

							<v-divider class="mt-2 mx-3 mb-3"></v-divider>

							<v-card-text class="py-0 inner-scroll__scroller">
								<ul class="attributes-list">
									<template
										v-for="attribute in nonHiddenAttributes"
									>
										<li :key="attribute.id">
											<span
												class="attributes-list__title"
											>
												{{ attribute.name }}
												<span
													v-if="
														attribute.units &&
															attribute.name !=
																'Lifting Capacity'
													"
												>
													({{ attribute.units }})
												</span>
											</span>
											<v-spacer></v-spacer>
											<span
												class="attributes-list__value"
											>
												{{ attribute.value }}
												<span
													v-if="
														attribute.units &&
															attribute.name ==
																'Lifting Capacity'
													"
													v-text="
														parseFloat(
															attribute.value
														) > 1
															? attribute.units
															: attribute.units_singular
													"
													style="text-transform: capitalize"
												></span>
											</span>
										</li>
									</template>

									<li v-if="weight">
										<span class="attributes-list__title">
											Weight
											<span>(lbs)</span>
										</span>
										<v-spacer></v-spacer>
										<span class="attributes-list__value">{{
											weight
										}}</span>
									</li>

									<li v-if="leadTime">
										<span class="attributes-list__title">
											Lead Time
											<span>({{ leadTimeMeasure }})</span>
										</span>
										<v-spacer></v-spacer>
										<span class="attributes-list__value">{{
											leadTime
										}}</span>
									</li>
								</ul>
								<!-- <code>{{product.attributes}}</code> -->
							</v-card-text>
						</div>
					</v-card>

					<v-card-actions class="pb-0 px-0" v-if="!edit">
						<v-btn flat @click="back">
							<div class="v-icon v-icon--left">
								<fa-icon
									:icon="['far', 'chevron-left']"
									transform="shrink-4"
									size="xs"
								/>
							</div>
							Back
						</v-btn>
						<v-spacer></v-spacer>
						<!-- <v-btn flat exact :to="getBuilderUrl(currentDocument, 1)">
										<div class="v-icon v-icon--left">
											<fa-icon :icon="['far', 'plus']" transform="shrink-4" size="xs"/>
										</div>Add Another Product
						</v-btn>-->
					</v-card-actions>
				</v-flex>

				<v-flex class="fill-height customize__options">
					<v-card class="fill-height scroll-card" color="lightbg">
						<div class="quote-builder__card-inner inner-scroll">
							<v-card-title class="py-0">
								<h3
									class="subheading font-weight-bold secondary--text"
								>
									b. Choose Options
								</h3>
							</v-card-title>

							<v-divider class="mt-2 mx-3 mb-3"></v-divider>

							<v-card-text class="inner-scroll__scroller py-0">
								<product-options
									:options="configurableOptions"
									:configuration.sync="configuration"
									:errors="errors"
									:showErrors="showErrors"
								></product-options>
								<!-- <code>{{ configuration }}</code> -->
								<!-- <code>{{ modifiedOptions }}</code> -->
							</v-card-text>
						</div>
					</v-card>
				</v-flex>

				<v-flex class="fill-height customize__summary">
					<v-card
						class="fill-height scroll-card"
						color="transparent"
						flat
					>
						<div class="quote-builder__card-inner inner-scroll">
							<v-card-title class="py-0">
								<h3
									class="subheading font-weight-bold secondary--text"
								>
									c. Review Product
								</h3>
							</v-card-title>

							<v-divider class="mt-2 mx-3 mb-3"></v-divider>

							<v-card-text class="pt-0">
								<v-img
									:src="getObjectValue('photo_url', product)"
									aspect-ratio="3"
									contain
									:style="
										product.part_family.slug ===
										'nutting-carts-trailers'
											? 'background-color: #FFFFFF;'
											: 'background-color: #00529c;'
									"
								></v-img>
							</v-card-text>

							<v-card-text class="inner-scroll__scroller py-0">
								<div class="d-flex align-end">
									<div>
										<h4 class="title mb-1 grey--text">
											{{ product.part_family.name }}
										</h4>
										<h4 class="title mb-2 grey--text">
											#{{ product.display_sku }}
										</h4>
										<h3
											class="headline font-weight-bold mb-0"
										>
											{{ product.name }}
										</h3>
									</div>

									<div class="product-qty">
										<label class="product-qty__label"
											>QTY</label
										>
										<div class="product-qty__input-wrap">
											<input
												min="1"
												type="number"
												v-model="quantity"
												class="black--text"
											/>
											<div class="product-qty__actions">
												<v-btn
													small
													depressed
													color="accent lighten-1"
													class="white--text"
													@click="addQty()"
												>
													<div class="v-icon">
														<fa-icon
															:icon="[
																'far',
																'chevron-up'
															]"
															transform="shrink-4"
															size="xs"
															fixed-width
														/>
													</div>
												</v-btn>
												<v-btn
													small
													depressed
													color="accent lighten-1"
													class="white--text"
													@click="removeQty()"
												>
													<div class="v-icon">
														<fa-icon
															:icon="[
																'far',
																'chevron-down'
															]"
															transform="shrink-4"
															size="xs"
															fixed-width
														/>
													</div>
												</v-btn>
											</div>
										</div>
									</div>
								</div>

								<transition name="fade">
									<div
										class="selected-options mt-2"
										v-if="modifiedOptions.length > 0"
									>
										<label class="selected-options__label"
											>SELECTED OPTIONS</label
										>
										<transition-group
											name="fade"
											class="selected-options__list"
											tag="ul"
											appear
										>
											<li
												v-for="mod in modifiedOptions"
												:key="mod.slug"
											>
												<div
													class="selected-options__text"
												>
													<div
														class="selected-options__label"
													>
														<span
															:class="{
																colon:
																	mod.type !==
																	'bool'
															}"
														>
															{{ mod.name }}
														</span>
														<span
															v-if="
																mod.type !==
																	'bool'
															"
															>{{ mod.value }}
															<span
																v-if="
																	mod.units &&
																		mod.type ===
																			'int'
																"
																v-text="
																	parseFloat(
																		mod.value
																	) > 1
																		? mod.units
																		: mod.units_singular
																"
																style="text-transform: capitalize"
															>
															</span>
														</span>
													</div>
													<div
														class="selected-options__price"
														v-if="mod.price"
													>
														{{
															mod.price | currency
														}}
													</div>
												</div>
												<v-btn
													icon
													small
													class="selected-options__clear"
													@click="
														resetOption(
															mod.slug,
															mod.default
														)
													"
													v-if="mod.is_removable"
												>
													<div class="v-icon">
														<fa-icon
															:icon="[
																'fal',
																'minus-circle'
															]"
															size="sm"
														/>
													</div>
												</v-btn>
											</li>
										</transition-group>
									</div>
								</transition>
							</v-card-text>

							<v-divider class="ma-3"></v-divider>

							<v-card-title class="py-0">
								<v-spacer v-if="privacy"></v-spacer>
								<div
									class="customize__price customize__price--list"
								>
									Suggested List Price
									<div class="title">
										{{ listPrice | currency }}
									</div>
								</div>
								<v-spacer v-if="!privacy"></v-spacer>
								<div
									class="customize__price customize__price--net"
									v-if="!privacy"
								>
									Dealer Net Price
									<div class="title success--text">
										{{ netPrice | currency }}
									</div>
								</div>
							</v-card-title>

							<v-card-text class="pb-0">
								<div class="text-xs-center">
									<v-btn
										large
										@click="addProduct(product)"
										color="primary"
										v-if="!edit"
										>Add To Quote
									</v-btn>
									<v-btn
										large
										@click="updateLineItem(product)"
										color="primary"
										v-else
										>Update Product
									</v-btn>
								</div>
							</v-card-text>
						</div>
					</v-card>
				</v-flex>

				<transition name="drawing-drawer">
					<v-flex
						sm8
						class="drawing-drawer"
						fill-height
						v-if="drawingDrawer"
					>
						<v-card class="fill-height scroll-card">
							<div class="quote-builder__card-inner inner-scroll">
								<v-card-title class="py-0">
									<h3
										class="subheading font-weight-bold secondary--text"
									>
										Drawings
									</h3>

									<v-spacer></v-spacer>

									<v-btn
										icon
										small
										@click="drawingDrawer = !drawingDrawer"
										class="ma-0"
									>
										<fa-icon
											:icon="['fal', 'times-circle']"
											class
											size="2x"
										/>
									</v-btn>
								</v-card-title>

								<v-divider class="mt-2 mx-3 mb-3"></v-divider>

								<v-card-text
									class="py-0 drawing-drawer__imgs inner-scroll__scroller"
								>
									<img
										:src="attachment.path"
										v-for="attachment in product.drawings"
										:key="attachment.path"
									/>
								</v-card-text>
							</div>
						</v-card>
					</v-flex>
				</transition>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters, mapMutations } from "vuex";
import ProductOptions from "@components/partials/ProductOptions";

var { mainRoutes } = require("@root/mixins");

export default {
	mixins: [mainRoutes],

	data() {
		return {
			quantity: 1,
			configuration: {},
			attributes: [],

			drawingDrawer: false,
			showErrors: false
		};
	},

	components: { ProductOptions },

	props: {
		category: {
			default: null
		},

		sku: {
			default: null
		},

		line_item: {
			default: null
		},

		edit: {
			default: false
		}
	},

	computed: {
		...mapGetters(["privacy", "user"]),

		...mapGetters("products", ["products", "selectedProduct"]),

		product() {
			if (this.edit) {
				return this.getObjectValue("part", this.getLineItem);
			}

			return this.selectedProduct;
		},

		nonHiddenAttributes() {
			return this.attributes.filter(attribute => {
				return (
					!attribute.hidden && attribute.field_configuration === null
				);
			});
		},

		options() {
			return _.filter(this.attributes, attribute => {
				const isHidden = this.getObjectValue(
					"field_configuration.is_hidden",
					attribute,
					true,
					true,
					true
				);
				return !isHidden;
			});
		},

		errors() {
			const errors = {};

			for (const {
				field_configuration: { required },
				slug
			} of this.configurableOptions) {
				const value = this.configuration[slug];

				if (required && !value) {
					errors[slug] = "This field is required.";
				}
			}

			return errors;
		},

		isValid() {
			return Object.keys(this.errors).length === 0;
		},

		configurableOptions() {
			return _.filter(this.attributes, attribute => {
				let restrictions = this.getObjectValue(
					"field_configuration.restriction",
					attribute
				);

				if (restrictions !== null) {
					let available = true;
					_.forEach(restrictions, restriction => {
						let basedOnOption = _.find(this.options, option => {
							return option.slug === restriction.slug;
						});

						if (!basedOnOption) {
							return true;
						}

						let basedOnValue = this.getObjectValue(
							"value",
							restriction,
							null,
							true
						);

						let basedOnComparison = this.getObjectValue(
							"comparison",
							restriction
						);

						let basedOnOptionType = this.getObjectValue(
							"field_configuration.type",
							basedOnOption
						);

						let value = this.configuration[basedOnOption.slug];

						if (value !== null && value instanceof Object) {
							value = value.value;
						}

						if (basedOnComparison === "R") {
							if (
								!value &&
								this.getObjectValue(
									attribute.slug,
									this.configuration,
									false,
									true
								)
							) {
								this.configuration[basedOnOption.slug] = true;
							}

							return true;
						}

						let productRestriction = this.getObjectValue(
							"restriction",
							_.find(this.attributes, { slug: attribute.slug }),
							{}
						);

						// if ( typeof basedOnValue === "string" ) basedOnValue = !!basedOnValue;
						// if ( typeof value === "string" ) value = !!value;

						let isAvailable = false;

						if (basedOnValue !== null) {
							isAvailable = this.isAvailable(
								basedOnComparison,
								value,
								basedOnValue
							);
							let selected_plug = null;
							let motions = null;

							if (restriction.strict_display) {
								selected_plug = this.configuration[
									restriction.slug
								];
								const conf_value = selected_plug.value;
								motions = this.getPendantPricingWithQDPlugFormat(
									conf_value
								);

								if (motions) {
									isAvailable = restriction.strict_values.find(
										v => v === value
									); // show or hide element
									// console.log('the value', value,restriction.values );
									if (restriction.strict_by === "length") {
										const len = motions.motions.length;
										const atts_value = attribute.field_configuration.values.find(
											v => +v.value === len
										);
										this.$set(
											this.configuration,
											attribute.slug,
											atts_value
										);
									} else if (
										restriction.strict_by === "value"
									) {
										const idx_val =
											motions.motions[
												restriction.strict_index
											];
										const atts_value = attribute.field_configuration.values.find(
											v => v.value === idx_val
										);
										this.$set(
											this.configuration,
											attribute.slug,
											atts_value
										);
									} else if (
										restriction.strict_by === "exist"
									) {
										// console.log('exist', attribute, restriction, value);
										const existed = restriction.strict_values.findIndex(
											v => v.value === value
										);
										this.$set(
											this.configuration,
											attribute.slug,
											!!existed
										);
									}
								}
							}

							// if ( _.isObject(this.configuration[ restriction.slug ]) && restriction['strict_display'] ) {
							// 	selected_plug = this.configuration[ restriction.slug ];
							// 	console.log('typeof selected_plug', selected_plug);
							// 	// if(selected_plug !== null){
							// 	// 	console.log( "selected_plug", selected_plug );
							// 	// 	motions = this.getPendantPricingWithQDPlugFormat( selected_plug.value );
							// 	// 	console.log( "motions", motions );
							// 	//
							// 	// 	if(motions){
							// 	//
							// 	// 	}
							// 	// }
							// 	if(_.isObject(selected_plug) && 'value' in selected_plug && selected_plug.value !== value){
							// 		// isAvailable = false;
							// 	}else{
							//
							// 	}
							// }

							available = isAvailable ? available : isAvailable;

							if (attribute.name === "Number of Motions") {
								// console.log("available", available);
							}
						} else if (basedOnOptionType === "int") {
							let min = this.getObjectValue(
								"min",
								productRestriction,
								0
							);
							let max = this.getObjectValue(
								"max",
								productRestriction,
								9999
							);

							if (max === 0) {
								max = this.getObjectValue(
									"field_configuration.max",
									basedOnOption,
									9999
								);
							}

							if (value < min || value > max) {
								available = false;
							}
						} else if (basedOnOptionType === "bool") {
							// const value = this.getObjectValue( "value", productRestriction, false, true );

							const configurationValue = this.getObjectValue(
								basedOnOption.slug,
								this.configuration,
								false,
								true
							);

							available = configurationValue === true;
						}

						if (!available) {
							this.$set(
								this.configuration,
								attribute.slug,
								available
							);
						} else {
							const type = this.getObjectValue(
								"field_configuration.type",
								attribute,
								"bool"
							);

							if (["int", "text"].indexOf(type) !== -1) {
								// console.log("attribute", attribute);
								const defaultValue = this.getObjectValue(
									"field_configuration.default",
									attribute,
									false,
									true
								);

								if (
									defaultValue !== false ||
									defaultValue !== "false"
								) {
									// console.log("defaultValue", defaultValue);
									this.$set(
										this.configuration,
										attribute.slug,
										defaultValue
									);
								}
							}

							const autoApply = this.getObjectValue(
								"auto_apply",
								restriction,
								false,
								true
							);

							// autoApply sets the value initially to true
							if (autoApply) {
								this.$set(
									this.configuration,
									attribute.slug,
									true
								);
							}
						}
					});

					return available;
				}

				return attribute.field_configuration;
			});
		},

		modifiedOptions() {
			const mods = [];

			_.forEach(this.configurableOptions, option => {
				const configurationValue = this.getObjectValue(
					option.slug,
					this.configuration,
					false,
					true
				);

				const isHidden = this.getObjectValue(
					"field_configuration.is_hidden",
					option,
					true,
					true,
					true
				);

				if (configurationValue !== false && !isHidden) {
					let value = this.getObjectValue(
						option.slug,
						this.configuration,
						false,
						true
					);

					if (value !== null && value instanceof Object) {
						value = value.name;
					}

					const isRemovable = this.getObjectValue(
						"field_configuration.is_removable",
						option
					);

					const isDisabled = this.getObjectValue(
						"disabled",
						option,
						false,
						true
					);

					const price = this.getModifiedOptionPrice(
						option.slug,
						this.configuration[option.slug]
					);

					mods.push({
						name: option.name,
						slug: option.slug,
						units: option.units,
						units_singular: option.units_singular,
						label: option.field_configuration.label,
						// display: display ? display : value,
						value,
						default: option.value,
						type: option.field_configuration.type,
						price,
						weight: option.weight,
						is_removable: isRemovable || isDisabled
					});
				}
			});

			return mods;
		},

		motions() {
			const optionalPendantWithQuickDisconnect = this.getObjectValue(
				"optional-pendant-with-qd-plug",
				this.configuration,
				false,
				true
			);

			if (optionalPendantWithQuickDisconnect) {
				let numberOfMotions = this.configuration["number-of-motions"];
				let motions = _.sortBy(
					_.reduce(
						this.configuration,
						(carry, option, slug) => {
							const value = this.getObjectValue("value", option);

							if (
								/(first|second|third)-motion/.exec(slug) &&
								value
							) {
								carry.push(value);
							}

							return carry;
						},
						[]
					),
					[value => value]
				);

				if (
					this.getObjectValue(
						"onoff-switch",
						this.configuration,
						false,
						true
					)
				) {
					motions.push("1A");
				}

				return motions;
			}

			return [];
		},

		getLineItem() {
			return this.currentDocument.line_items.find(item => {
				return item.id == this.line_item;
			});
		},

		getCategoryName() {
			if (this.edit) {
				return this.getObjectValue("product.part_family.slug", this);
			}

			return this.category;
		},

		listPrice() {
			let price = this.product.price;

			_.forIn(this.configuration, (value, key) => {
				price += this.getModifiedOptionPrice(key, value);
			});

			return price;
		},

		netPrice() {
			// console.log('netprice this');
			// console.log(this);
			const modifier = this.getObjectValue(
				"modifier",
				this.product.part_family,
				1
			);
			//console.log(this.listPrice);
			//console.log(modifier);
			//console.log(this.listPrice * modifier);
			return this.listPrice * modifier;
		},

		weight() {
			let weight = _.reduce(
				this.configuration,
				(carry, value, key) => {
					return carry + this.getModifiedOptionWeight(key, value);
				},
				this.getObjectValue("weight", this.product, 0)
			);

			return Math.round(weight * 100) / 100;
		},

		leadTime() {
			return this.getObjectValue("lead_time", this.product);
		},

		leadTimeMeasure() {
			return this.getObjectValue("lead_time_measure", this.product);
		},

		maxQuantityTotal() {
			switch (this.getCategoryName) {
				case "stock-wire-rope-hoist":
				case "wright-end-trucks":
					return 2;

				default:
					return 5;
			}
		},

		maxQuantity() {
			let totalQuantity = 0;

			for (const { id, part, quantity } of this.currentDocument
				.line_items) {
				const categorySlug = part.part_family.slug;

				if (
					categorySlug === this.getCategoryName &&
					+id !== +this.line_item
				) {
					totalQuantity += quantity;
				}
			}

			return this.maxQuantityTotal - totalQuantity;

			// return this.maxQuantityTotal;
		},

		phoneNumber() {
			const categorySlug = this.getCategoryName;

			if (categorySlug === "nutting-carts-trailers") {
				return {
					title: "Order Nutting by Phone",
					phone: "1-800-533-0337"
				};
			}

			return {
				title: "Order by Phone",
				phone: "1-800-967-7333"
			};
		}
	},

	methods: {
		...mapMutations(["SET_VALUE", "SET_HIDDEN_VALUE"]),
		...mapMutations("documents", ["removeLineItem"]),

		...mapActions("quote-builder", {
			ADD_REMOVE_PRODUCT: "addRemoveProduct",
			REMOVE_LINE_ITEM: "removeLineItem",
			UPDATE_PART: "updatePart"
		}),

		...mapActions("products", {
			GET_PRODUCT: "getProduct"
		}),

		addQty() {
			const newQuantity = +this.quantity + 1;

			// if (newQuantity > this.maxQuantity) {
			// 	this.$swal({
			// 		title: "Quantity Error",
			// 		html: `Please call the factory to coordinate your order for bigger quantities.
			// 			<br />
			// 			<br />
			// 			<b>${this.phoneNumber.title}</b>: ${this.phoneNumber.phone}`,
			// 		type: "error",
			// 		confirmButtonText: "OK"
			// 	});
			// 	return;
			// }

			this.quantity = newQuantity;
		},

		removeQty() {
			if (this.quantity > 1) {
				this.quantity -= 1;
			}
		},

		resetOption(slug, value) {
			this.$set(this.configuration, slug, value);

			this.onRadioControlChange();
		},

		back() {
			this.$swal({
				title: "Wait!",
				text:
					"If you go back you will lose the configuration of the current product. Would you like to add it to your quote first?",
				type: "warning",
				showCancelButton: true,
				confirmButtonText: "Add To Quote",
				cancelButtonText: "Go Back"
			}).then(result => {
				if (result.value) {
					this.addProduct(this.product);
				} else if (result.dismiss === this.$swal.DismissReason.cancel) {
					const path = this.getBuilderUrl(this.document, 2, {
						category: this.getCategoryName
					});

					this.$router.push({ path });
				}
			});
		},

		addProduct(product) {
			if (!this.isValid) {
				this.showErrors = true;
				return;
			}

			this.ADD_REMOVE_PRODUCT({
				document_number: this.number,
				params: product,
				quantity: this.quantity,
				additional_params: {
					configuration: this.configuration
				}
			}).then(data => {
				this.$swal({
					title: "Success",
					text: "Your product has been added to the quote..",
					type: "success",
					showCancelButton: true,
					confirmButtonText: "Next Step",
					cancelButtonText: "Add Another Product"
				}).then(result => {
					if (result.value) {
						this.nextStep(4);
					} else if (
						result.dismiss === this.$swal.DismissReason.cancel
					) {
						const path = this.getBuilderUrl(this.document, 1);

						this.$router.push({ path });
					}
				});
			});
		},

		updateLineItem(product, merge = false) {
			if (!this.line_item) {
				return;
			}

			let payload = {
				document_number: this.number,
				line_item: this.getLineItem,
				quantity: this.quantity,
				name: null,
				price: this.quote_price,
				additional_params: {
					configuration: this.configuration
				}
			};

			if (merge) {
				payload.additional_params.merge = true;
			}

			this.UPDATE_PART(payload)
				.then(data => {
					this.editing = false;
					if (data.id != this.line_item) {
						this.removeLineItem({
							document_number: this.number,
							id: this.line_item
						});

						this.$router.replace(
							this.getBuilderUrl(this.document, 4)
						);

						return;
					}

					this.nextStep(4);
				})
				.catch(e => {
					if (
						this.getObjectValue("response.status", e, 400) === 412
					) {
						this.$swal({
							title: "Wait!",
							text:
								"It appears that your new configuration matches another product in your cart. Do you want to merge the two lines or cancel?",
							type: "warning",
							showCancelButton: true,
							confirmButtonText: "Merge Lines",
							cancelButtonText: "Cancel"
						}).then(result => {
							if (result.value) {
								this.updateLineItem(product, true);
							}
						});
					} else {
						// console.log(e.response);
					}
				});
		},

		setConfiguration() {
			this.attributes = _.cloneDeep(this.product.attributes);

			this.setUpWatchers().then(() => {
				const defaults = this.options.reduce((carry, item) => {
					carry[item.slug] = item.value;

					return carry;
				}, {});

				// console.log("defaults", defaults);

				const config = Object.assign(
					{},
					defaults,
					this.getObjectValue("configuration", this.getLineItem, {})
				);

				const attribute = _.find(this.attributes, {
					slug: "hoist-lift-fixed"
				});

				if (attribute) {
					const hoistLift = +this.getObjectValue(
						"value",
						attribute,
						""
					);

					if (!isNaN(hoistLift)) {
						config["hoist-lift"] = hoistLift;
					}
				}

				// console.log("config", config);

				this.$set(this, "configuration", config);
			});
		},

		async setUpWatchers() {
			const pendantSlugs = [
				"first-motion",
				"second-motion",
				"third-motion",
				"onoff-switch"
			];

			pendantSlugs.forEach(slug => {
				if (this.configuration[slug]) {
					this.$watch(() => this.configuration[slug], {
						handler: "resetPendantValues"
					});
				}
			});

			// if (this.configuration["first-motion"]) {
			//   this.$watch(() => this.configuration["first-motion"], {
			//     handler: "resetPendantValues"
			//   });
			// }
			// if (this.configuration["second-motion"]) {
			//   this.$watch(() => this.configuration["second-motion"], {
			//     handler: "resetPendantValues"
			//   });
			// }
			// if (this.configuration["third-motion"]) {
			//   this.$watch(() => this.configuration["third-motion"], {
			//     handler: "resetPendantValues"
			//   });
			// }
			// if (this.configuration["onoff-switch"]) {
			//   this.$watch(() => this.configuration["onoff-switch"], {
			//     handler: "resetPendantValues"
			//   });
			// }

			if (this.configuration["radio-control"]) {
				this.$watch(() => this.configuration["radio-control"], {
					handler: "onRadioControlChange"
				});
			}

			return true;
		},

		getModifiedOptionPrice(key, value) {
			// if (key === "hoist-lift") {
			// 	if (typeof this.attributes[key] === "undefined") {
			// 		key = "hoist-lift-fixed";
			// 	}
			// }

			let attribute = _.find(this.attributes, { slug: key });
			if (!attribute) {
				console.log("could not find", key, value);
				return 0;
			}

			let price = this.getObjectValue("price", attribute, 0);

			if (value !== null && value instanceof Object) {
				price = this.getObjectValue("price", value, 0);
				value = this.getObjectValue("name", value, 0);
			}

			// do not add price to hoist-lift
			if (
				key === "hoist-lift" &&
				(this.configuration["galvanized-load-chain"] ||
					this.configuration["optional-nickel-plated-load-chain"])
			) {
				return 0;
			}

			if (attribute.restriction && attribute.restriction.price_based_on) {
				const { slug, prices } = attribute.restriction.price_based_on;
				const config = this.configuration[slug];

				if (_.isPlainObject(config)) {
					const { value } = config;
					const p = prices[value];

					if (p) {
						price = p;
					}
				}
			}

			if (price) {
				if (
					this.getObjectValue(
						"field_configuration.type",
						attribute
					) === "bool" &&
					!value
				) {
					return 0;
				}

				let basedOnAttribute = attribute;

				if (attribute.based_on !== null) {
					basedOnAttribute = this.getBasedOnAttribute(
						attribute.based_on
					);
				}

				let fieldConfiguration = basedOnAttribute.field_configuration;

				if (fieldConfiguration) {
					if (fieldConfiguration.type === "int") {
						const a = parseInt(
							this.getObjectValue(
								basedOnAttribute.slug,
								this.configuration,
								basedOnAttribute.value
							)
						);

						const b = attribute.is_addition
							? basedOnAttribute.value
							: 0;

						let multiplier = a - b;

						if (!attribute.is_discountable && multiplier < 0) {
							multiplier = 0;
						}

						price = price * multiplier;
					} else if (fieldConfiguration.type === "bool") {
						let multiplier = 1;

						price = price * multiplier;
					}
				}
			}

			return price;
		},

		getModifiedOptionWeight(key, value) {
			let attribute = _.find(this.attributes, { slug: key });
			let weight = this.getObjectValue("weight", attribute, 0);

			if (value !== null && value instanceof Object) {
				weight = this.getObjectValue("weight", value, 0);
				value = this.getObjectValue("name", value, "");
			}

			if (weight) {
				const type = this.getObjectValue(
					"field_configuration.type",
					attribute
				);

				if (type === "bool" && !value) {
					return 0;
				}

				let basedOnAttribute = attribute;

				if (attribute.based_on !== null) {
					basedOnAttribute = this.getBasedOnAttribute(
						attribute.based_on
					);
				}

				let fieldConfiguration = basedOnAttribute.field_configuration;

				if (fieldConfiguration) {
					if (fieldConfiguration.type === "int") {
						const a = parseInt(
							this.getObjectValue(
								basedOnAttribute.slug,
								this.configuration,
								basedOnAttribute.value
							)
						);

						const b = attribute.is_addition
							? basedOnAttribute.value
							: 0;

						const multiplier = a - b;

						weight = weight * multiplier;
					} else if (fieldConfiguration.type === "bool") {
						const multiplier = 1;

						weight = weight * multiplier;
					}
				}
			}

			return weight;
		},

		getBasedOnAttribute(slug) {
			let basedOnAttribute = _.find(this.attributes, { slug });

			if (basedOnAttribute === undefined) {
				basedOnAttribute = _.find(this.attributes, {
					slug: `${slug}-fixed`
				});
			}

			return basedOnAttribute;
		},

		onRadioControlChange() {
			const dependantAttribute = "radio-control";
			const attributeSlug = "mainline-contactor";

			const attributeIndex = _.findIndex(this.attributes, {
				slug: attributeSlug
			});

			if (attributeIndex !== -1) {
				const available = Boolean(
					this.getObjectValue(
						dependantAttribute,
						this.configuration,
						""
					)
				);
				const isHidden = !available;

				const attribute = this.attributes[attributeIndex];
				attribute.is_disabled = Number(available);
				attribute.hidden = Number(isHidden);

				// Important: changing the value here causes things to not work
				// because the core of this was built assuming that the
				// attributes are immutable. This changed, and the core
				// implementation needs to change at some point.
				// attribute.value = available;

				attribute.field_configuration = _.assign(
					attribute.field_configuration || {},
					{
						is_hidden: isHidden,
						is_removable: !available
					}
				);

				this.$set(this.attributes, attributeIndex, attribute);
				this.$set(this.configuration, attributeSlug, available);
			}
		},

		resetPendantValues() {
			// console.log("resetPendantValues");

			const setConfigurationValues = (slug, value) => {
				if (this.configuration[slug] === value) {
					return;
				}

				const option = _.find(this.options, { slug });

				const values = this.getObjectValue(
					"field_configuration.values",
					option,
					[]
				);

				this.$set(this.configuration, slug, _.find(values, { value }));
			};

			setConfigurationValues(
				"pendant-pricing-with-qd-plug",
				_.join(this.motions, "")
			);

			const numberOfConductors = _.reduce(
				this.motions,
				(carry, value) => {
					if (value === "1") {
						carry += 2;
					} else if (value === "2") {
						carry += 3;
					} else if (value === "1A") {
						carry += 2;
					}

					return carry;
				},
				2
			);

			setConfigurationValues(
				"pendant-cord-strain-chain",
				numberOfConductors <= 8 ? "8" : "14"
			);
		},
		isAvailable(basedOnComparison, value, basedOnValue) {
			let isAvailable = false;
			switch (basedOnComparison) {
				case "<":
					isAvailable = value < basedOnValue;
					break;
				case "<=":
					isAvailable = value <= basedOnValue;
					break;
				case ">":
					isAvailable = value > basedOnValue;
					break;
				case ">=":
					isAvailable = value >= basedOnValue;
					break;
				case "!=":
					isAvailable = value != basedOnValue;
					break;
				default:
					isAvailable = value == basedOnValue;
					break;
			}

			return isAvailable;
		},
		getPendantPricingWithQDPlugFormat(PendantPricingValue) {
			// if ( slug === "pendant-pricing-with-qd-plug" ) {
			if (!PendantPricingValue) return false;

			const vals = PendantPricingValue.split(/(1A)/).reduce((a, c) => {
				if (c === "1A") {
					a.push(c);
				} else {
					a = a.concat(c.split(""));
				}
				return a;
			}, []);
			let on_off_switch = null;
			const motions = [];

			vals.forEach(m =>
				m === "1A" ? (on_off_switch = m) : motions.push(m)
			);

			return {
				motions,
				onOffSwitch: !!on_off_switch
			};
		}
	},

	created() {
		if (!this.edit) {
			if (this.maxQuantity === 0) {
				this.quantity = 0;
			}

			if (
				!this.selectedProduct ||
				this.sku !== this.selectedProduct.sku
			) {
				this.GET_PRODUCT(this.sku).then(({ data }) => {
					this.SET_VALUE({
						name: "products.selectedProduct",
						value: data
					});

					this.setConfiguration();
				});
			} else {
				this.setConfiguration();
			}
		} else {
			this.setConfiguration();

			this.quantity = this.getObjectValue(
				"quantity",
				this.getLineItem,
				1
			);
		}
	},

	watch: {
		// 'product.attributes': {
		// 	handler(value) {
		// 		const attribute = _.find(value, { 'slug': 'hoist-lift-fixed' });
		//
		// 		let hoistLift = Number(attribute.value);
		//
		// 		if(!isNaN(hoistLift)) {
		// 			this.configuration['hoist-lift'] = attribute.value;
		// 		}
		// 	},
		// 	deep: true,
		// }
	}
};
</script>

<style lang="scss" scoped>
.flex-column__row--full {
	position: relative;
}
</style>
